import { FC } from 'react';

import { ResourceTypeExplorer } from '@dbt-labs/dbt-dag';

import { useFilterContext } from '@/context/FilterProvider';
import { useSearchFacets } from '@/context/SearchFacetsProvider';
import {
  ALL_DIVEABLE_RESOURCE_TYPES,
  ALL_FILTERABLE_RESOURCE_TYPES,
} from '@/typings/search';
import { ClearSelectAllButton } from './ClearSelectAllButton';
import { FilterSection, FilterSectionProps } from './FilterSection';
import { ResourceFilterToggle } from './ResourceFilterToggle';
interface TypeFiltersProps extends FilterSectionProps {
  onDive?: (resourceType: ResourceTypeExplorer) => void;
}

export const TypeFilters: FC<TypeFiltersProps> = ({ title = 'Type', onDive }) => {
  const filterCtx = useFilterContext();
  const { aggregations } = useSearchFacets();

  const filterableResourceTypes = ALL_FILTERABLE_RESOURCE_TYPES;

  return (
    <FilterSection title={title} enableExpansion isDefaultExpanded>
      {filterableResourceTypes.map((resourceType) => (
        <ResourceFilterToggle
          key={resourceType}
          resourceType={resourceType}
          isChecked={filterCtx.filters.resourceType?.includes(resourceType)}
          onToggle={filterCtx.updateFilters}
          onDive={
            ALL_DIVEABLE_RESOURCE_TYPES.includes(resourceType) ? onDive : undefined
          }
          count={aggregations?.assetType?.[resourceType]}
        />
      ))}

      <ClearSelectAllButton
        type="resourceType"
        selectedList={filterCtx.filters.resourceType}
        selectionList={filterableResourceTypes.map((resourceType) => ({
          label: resourceType,
          value: resourceType,
        }))}
      />
    </FilterSection>
  );
};
